































import { defineComponent, PropType, ref, toRef, watch } from "@vue/composition-api";
import { LiveChatInvitation } from "@scrile/api-provider/dist/api/LivechatsProvider";
import BaseButton from "@/components/BaseButton";
import BaseIcon from "@/components/BaseIcon";
import CustomScroll from "@/components/CustomScroll";
import PrivateInvitationItem from "../PrivateInvitationItem";

export default defineComponent({
  name: "PrivateInvitationsList",
  components: { PrivateInvitationItem, CustomScroll, BaseIcon, BaseButton },
  props: {
    invitations: { type: Array as PropType<LiveChatInvitation[]>, default: () => [] },
  },
  setup(props) {
    const showList = ref(false);

    watch(toRef(props, "invitations"), newVal => {
      if (!newVal.length) {
        showList.value = false;
      }
    });

    return { showList };
  },
});
